<template>

    <div v-if="showFaq" class="col-12 faq-template">

        <div v-if="Object.keys(errors).length && showMessage" class="confirmation bg-danger">
            <ul class="errors">
                <li v-for="(error, index) in errors" :key="'error-' + index">{{ error }}</li>
            </ul>
        </div>

        <div v-if="showMessage && successMessage !== ''" class="bg-success confirmation">
            <p>{{ successMessage }}</p>
        </div>

        <h1>{{ language.title }}</h1>

        <p>{{ language.info }}</p>

        <form enctype="multipart/form-data">

            <div class="row">

                <div class="col-12 col-lg-6">

                    <div class="form-group" :class="{ error: errors.hasOwnProperty('currentQuestion') }">
                        <label for="current-question">{{ language.question }}</label>
                        <input type="text" id="current-question" class="form-control" name="current-question" v-model="currentQuestion" />
                    </div>
                </div>

                <div class="col-12 col-lg-6">
                    <div class="form-group" :class="{ error: errors.hasOwnProperty('currentAnswer') }">
                        <label for="current-answer">{{ language.answer }}</label>
                        <textarea id="current-answer" rows="6" class="form-control" name="current-answer" v-model="currentAnswer"></textarea>
                    </div>
                </div>

                <div class="col-12">
                    <button type="submit" class="btn btn-primary" v-on:click.prevent="submit">{{ language.add }}</button>
                </div>

            </div>

        </form>

        <table v-if="collected.length" class="table draggable">

            <thead>
                <tr>
                    <th scope="col">{{ language.answer }}</th>
                    <th scope="col">{{ language.question }}</th>
                    <th></th>
                </tr>
            </thead>

            <draggable tag="tbody" :list="collected" @start="drag=true" @end="drag=false" @change="onChange">
                <tr v-for="faq in collected" :key="faq.id">
                    <td>{{ faq.question }}</td>
                    <td>{{ faq.answer }}</td>
                    <td>
                        <div>
                            <button class="btn btn-warning" v-on:click.prevent="editQuestion(faq, collected)">{{ language.edit }}</button>

                            <delete-popup
                                @deleted="deletedFaq"
                                :translations="JSON.stringify(language)"
                                :route="`/api/delete-faq/${faq.id}`"
                                :name="faq.question"
                                :ajaxreq="true"
                                :text="language.prompt.replacePlaceholders({ name : faq.question })"
                                >
                            </delete-popup>

                        </div>
                    </td>
                </tr>
            </draggable>

        </table>

        <div class="general-popup" v-display-none="showEditWindow">
            <div class="wrapper" style="min-height: auto;">
                <span class="close-popup" v-on:click.prevent="showEditWindow=false"><i class="fas fa-times"></i></span>
                <form>
                    <input type="hidden" ref="editble-id" />

                    <div class="form-group">
                        <label for="current-question">{{ language.question }}</label>
                        <input type="text" ref="editble-question" id="current-question" class="form-control" name="current-question" />
                    </div>

                    <div class="form-group">
                        <label for="current-answer">{{ language.answer }}</label>
                        <textarea id="current-answer" ref="editble-answer" rows="6" class="form-control" name="current-answer"></textarea>
                    </div>

                    <div class="form-group">
                        <button type="submit" class="btn btn-primary" v-on:click.prevent="saveAll">{{ language.save }}</button>
                    </div>
                </form>
            </div>
        </div>

    </div>

</template>

<script>

import axios from "axios";
import DeletePopup from './DeletePopup'
import draggable from 'vuedraggable'
import dataStore from "../store";


export default {

    data() {
        return this.initialState();
    },

    props: {
        id : Number,
        translation : String
    },

    mounted() {
        this.getFaq()
    },

    components : {
        DeletePopup,
        draggable
    },

    methods : {

        getTranslations: function() {
            return axios.get('/api/translations/admin-faq')
        },

        initialState: function() {
            return {
                currentQuestion : '',
                currentAnswer : '',
                collected : [],
                errors : {},
                showMessage : false,
                dragSrcEl : null,
                dataStore,
                successMessage : '',
                showFaq : false,
                showEditWindow: false,
                language : null
            }
        },

        saveAll: function() {

            let id = this.$refs['editble-id'].value;
            let q = this.$refs['editble-question'].value;
            let a = this.$refs['editble-answer'].value;

            this.collected = this.collected.map(item => {

                if(item.id == id) {
                    Object.assign(item, { question : q, answer : a})
                }

                return item
            })

            axios.post(`/api/save-all-faq`,
                {
                    data : this.collected,
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
            .then(response => {
                this.collected = response.data
                this.showEditWindow = false;

            })
        },

        submit: function() {

            axios.post(`/api/faq`,
                {
                    data : this.$data,
                    id : this.id,
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
            .then(response => {

                if(response.data.errors) {
                    this.errors = response.data.errors;
                    this.showMessage = true;

                } else {

                    let state = this.initialState();
                    delete state.collected

                    Object.assign(this.$data, state);
                    this.getFaq()
                }

                window.scroll(0,0);

                setTimeout(() => {
                    this.showMessage = false
                } , 5000);

            })
        },

        getFaq: function() {

            this.getTranslations()

            .then(response => {

                this.language = response.data

                axios.get(`/api/get-faq/${this.id}`)

                .then(response => {
                    if(response.data) {
                        this.collected = response.data.collected.map(item => Object.assign(item, { edit : false }))
                        this.dataStore.project.faqEmail = response.data.email
                        this.showFaq = true
                    }
                })

            })

        },

        deletedFaq: function(deleted) {
            this.getFaq()
        },

        onChange: function(event) {
            axios.post(`/api/sort-faq`,
                {
                    data : this.collected,
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
        },

        editQuestion: function(faq, collected) {
            this.showEditWindow = true;
            this.$refs['editble-id'].value = faq.id;
            this.$refs['editble-question'].value = faq.question;
            this.$refs['editble-answer'].value = faq.answer;
        }
        
    },

    created : function() {
        this.showFaq = false
    }
};

</script>

